module.exports = __webpack_public_path__ + "static/media/header-doc.9d3fb4a5.jpeg";